require('./bootstrap');


// $('[data-toggle="tooltip"]').tooltip();
$('.form_pos').on('submit', function() {
    $('#submitBtn').attr('disabled', true);
});

$('.navbar-toggle-sidebar').click(function () {
    $('.navbar-nav-main').toggleClass('slide-in');
    $('#bs-example-navbar-collapse-1').removeClass('in');
});

$('.navbar-toggle-sidebar2').click(function () {
    $('.navbar-nav-main').removeClass('slide-in');
});

